export default "__VITE_ASSET__hUHL_357__"